import { Component, Inject, OnInit, signal } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { NgStyle } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

export interface DialogData {
  phonenumberSubmitted: boolean;
}
@Component({
  selector: 'app-verify-sms',
  templateUrl: './verify-sms.component.html',
  styleUrls: ['./verify-sms.component.scss'],
  imports: [
    MatDialogTitle,
    NgStyle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    TranslatePipe,
  ],
})
export class VerifySmsComponent implements OnInit {
  verifySmsForm: UntypedFormGroup;
  phonenumberSubmitted = signal(false);
  highContrast = signal(false);

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<VerifySmsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private translate: TranslateService,
    private snackbar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    console.log(this.data);
    this.verifySmsForm = this.fb.group({
      code: ['', [Validators.required]],
      phonenumber: ['', [Validators.required]],
    });

    if (localStorage.getItem('highContrast') && localStorage.getItem('highContrast') === '1') {
      this.highContrast.set(true);
    }

    this.phonenumberSubmitted.set(this.data.phonenumberSubmitted);
  }

  getSnackbar(message: string) {
    let snackbarMessage = this.translate.instant(`snackbar-messages.${message}`) as string;
    console.log('snackbarMessage', snackbarMessage);
    if (snackbarMessage.includes('snackbar-messages.')) {
      // translation not found, get oops error instead
      snackbarMessage = this.translate.instant(`snackbar-messages.something-went-wrong`) as string;
    }
    this.snackbar.open(snackbarMessage, 'X', {
      duration: 12000,
    });
    return message;
  }

  submit() {
    this.dialogRef.close({
      code: this.verifySmsForm.value.code,
      phonenumber: this.verifySmsForm.value.phonenumber,
    });
  }
}
